import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import Checkbox from 'apollo-react/components/Checkbox';
import FormGroup from 'apollo-react/components/FormGroup';
import Grid from 'apollo-react/components/Grid';
import TextField from 'apollo-react/components/TextField';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

import withTranslation from '../../../components/withTranslation';

const useStyles = makeStyles({
  container: {
    padding: 24,
  },
  scrollView: {
    height: 'calc(100vh - 72px)',
    overflowY: 'auto',
  },
});

const DocumentGoToPage = ({ translateString }) => {
  const classes = useStyles();

  return (
    <div className={classes.scrollView}>
      <Grid container className={classes.container}>
        <Grid item xs={12}>
          <Typography variant="h2" gutterBottom>
            {translateString('Go To')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <FormGroup>
            <TextField required label={translateString('Document No')} />
          </FormGroup>
          <FormGroup>
            <TextField required label={translateString('Document Revision')} />
          </FormGroup>
          <FormGroup>
            <Checkbox label={translateString('Latest Revision')} />
          </FormGroup>

          <Button variant="primary" style={{ marginTop: 16 }}>
            {translateString('View')}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default withTranslation(DocumentGoToPage);
